"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sleep = function (ms) { return new Promise(function (r) { return setTimeout(r, ms); }); };
exports.default = sleep;
//# sourceMappingURL=sleep.js.map